import axios from "axios";
import { API_URL } from "../config";
import authService from "./auth";
import { isConsultor } from "../utils/obterNomeExibicaoUsuario";

const TIPO_USUARIO_INTERESSADO = 0;

const getAuthHeader = () => {
  const user = authService.getCurrentUser();
  if (user && user.token) {
    return { Authorization: `Bearer ${user.token}` };
  }
  return {};
};

const usuarioService = {
  obterDados: async () => {
    try {
      const response = await axios.get(`${API_URL}Usuario/`, {
        headers: getAuthHeader(),
      });
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.detail || "Erro ao obter dados do usuário",
      );
    }
  },

  atualizarDados: async (dados) => {
    try {
      const limpar = (valor) => (valor ?? "").replace(/\D/g, "");

      const isInteressado =
        dados.tipoUsuario === TIPO_USUARIO_INTERESSADO ||
        dados.tipoUsuario === String(TIPO_USUARIO_INTERESSADO) ||
        isConsultor(dados);
      const isPessoaJuridica =
        dados.tipoUsuario === 4 || dados.tipoUsuario === "4";

      const enderecoFormatado =
        isInteressado || isPessoaJuridica
          ? {
              ...dados.endereco,
              numero: dados.endereco.numero
                ? String(dados.endereco.numero)
                : null,
              cep: limpar(dados.endereco.cep),
            }
          : null;

      const request = {
        ...dados,
        telefone: limpar(dados.telefone),
        endereco: enderecoFormatado,
        interessado: isInteressado ? dados.interessado : null,
        pessoaJuridica: isPessoaJuridica ? dados.pessoaJuridica : null,
      };

      const response = await axios.put(`${API_URL}usuario/`, request, {
        headers: getAuthHeader(),
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw error.response.data;
      }
      throw new Error("Erro ao atualizar dados");
    }
  },

  obterUsuarioPorId: async (id) => {
    try {
      const response = await axios.get(`${API_URL}Usuario/${id}`, {
        headers: getAuthHeader(),
      });
      return response.data?.data || response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.detail || "Erro ao obter dados do usuário",
      );
    }
  },

  obterContato: async (id) => {
    try {
      const response = await axios.get(`${API_URL}Usuario/${id}/contato`, {
        headers: getAuthHeader(),
      });
      return response.data?.data || response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.detail ||
          error.response?.data?.message ||
          "Erro ao obter contato do solicitante",
      );
    }
  },
};

export default usuarioService;
